import { render, staticRenderFns } from "./MindfulSurvey.vue?vue&type=template&id=b64c7380&scoped=true&"
import script from "./MindfulSurvey.vue?vue&type=script&lang=js&"
export * from "./MindfulSurvey.vue?vue&type=script&lang=js&"
import style0 from "./MindfulSurvey.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/mindful_survey.css?vue&type=style&index=1&id=b64c7380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64c7380",
  null
  
)

export default component.exports